/// <amd-module name="Environments/EnvironmentsCommon/Telemetry" />
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { IVssPageContext } from "VSS/Platform/Context";

export function publishTelemetry(pageContext: IVssPageContext, area: string, featureName: string, properties: { [key: string]: string } = {}): void {
    const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
    telemetryService.publishEvent(area, featureName, properties);
}
